(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/error/cancel-wager-error.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/error/cancel-wager-error.js');
'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const BaseError = svs.components.payment.common.error.BaseError;
const _svs$components$payme = svs.components.payment.common.error.constants,
  ClientErrorCodes = _svs$components$payme.ClientErrorCodes,
  ClientErrorMessages = _svs$components$payme.ClientErrorMessages;
const getClientCode = svs.components.payment.common.error.utils.getClientCode;

class CancelWagerError extends BaseError {
  constructor(_ref) {
    let clientCode = _ref.clientCode,
      code = _ref.code,
      extraData = _ref.extraData,
      errorMessage = _ref.message;
    const clientError = getClientCode(code);
    if (clientError.clientCode) {
      clientCode = clientError.clientCode;
    }
    const paymentMessage = ClientErrorCodes[clientCode] ? ClientErrorMessages[clientCode] : 'Cancel Wager error';
    const message = errorMessage || paymentMessage;
    super({
      clientCode,
      code,
      extraData,
      message
    });
    this.name = 'CancelWagerError';
  }
}
_defineProperty(CancelWagerError, "ClientErrorCodes", ClientErrorCodes);
setGlobal('svs.components.payment.common.error.CancelWagerError', CancelWagerError);

 })(window);